import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@ais-ui/ui-core';
import { PiDotsThreeVertical } from 'react-icons/pi';
import React, { useState } from 'react';
import { useAtonContext } from '../AtonContext';
import { DeleteAton } from '../Mutations/DeleteAton';
import { AtoN } from '@ais-ui/api-spec/config';
import { useLocalization } from '@ais-ui/locale-management';
import { noop } from 'lodash';

interface VirtualDropdownMenuProps {
  aton: AtoN;
  onEdit: () => void;
  onDelete: () => void;
  disabled: boolean;
}

interface DisabledVirtualDropdownMenuProps {
  aton: AtoN;
}

export const DisabledPhysicalDropdownMenu = ({
  aton,
}: DisabledVirtualDropdownMenuProps) => {
  return (
    <PhysicalDropdownMenu
      aton={aton}
      disabled={true}
      onDelete={noop}
      onEdit={noop}
    ></PhysicalDropdownMenu>
  );
};
export const EnabledPhysicalDropdownMenu = ({
  aton,
}: DisabledVirtualDropdownMenuProps) => {
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const { setMutateType, setShowDialog, setAtonType, setAton } =
    useAtonContext();

  const onDelete = () => {
    setShowDeleteDialog(true);
  };

  const onEdit = () => {
    setAton(aton);
    setMutateType('edit');
    setShowDialog(true);
    setAtonType('physical');
  };

  return (
    <>
      <PhysicalDropdownMenu
        aton={aton}
        disabled={false}
        onDelete={onDelete}
        onEdit={onEdit}
      ></PhysicalDropdownMenu>
      <DeleteAton
        aton={aton}
        showDialog={showDeleteDialog}
        setShowDialog={setShowDeleteDialog}
      />
    </>
  );
};
const PhysicalDropdownMenu = ({
  aton,
  onEdit,
  onDelete,
  disabled,
}: VirtualDropdownMenuProps) => {
  const { messages } = useLocalization();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          id={`${aton.name?.toLowerCase()}-dropdown-button`}
          size="icon"
          variant="ghost"
          className="h-8 w-8"
          disabled={disabled}
        >
          <PiDotsThreeVertical className="h-6 w-6" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={onEdit}>
          {messages.genericEdit}
        </DropdownMenuItem>
        <DropdownMenuItem onClick={onDelete}>
          {messages.genericDelete}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
